import {Tag} from "../../../../../components/ui/tag";
import {FieldType} from "../pages/populationsData";

/** Display label + colour for each field type, mirroring the app's FIELD_TYPE_INFO vocabulary. */
const FIELD_TYPE_INFO: Record<FieldType, {label: string; color: string}> = {
  text: {label: "Text", color: "gray"},
  date: {label: "Date", color: "blue"},
  number: {label: "Number", color: "purple"},
  currency: {label: "Currency", color: "green"},
  boolean: {label: "Boolean", color: "orange"},
};

/** A coloured badge for a typed field — used by the schema and test-procedures views. */
export const FieldTypeBadge = ({type}: {type: FieldType}) => {
  const {label, color} = FIELD_TYPE_INFO[type];
  return (
    <Tag size="sm" colorPalette={color} variant="surface">
      {label}
    </Tag>
  );
};
